export default "__VITE_ASSET__XaukwXrb__"